import {Tooltip} from '@material-ui/core';
import {PriceTier} from '@treez/commons/sharedTypings/priceTier';
import _ from 'lodash';
import React, {FunctionComponent, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {selectPriceTiersForOrganization} from '~/redux/selectors/organizationSelectors';

interface Props {
    tierId: number;
}

export const PriceTierLabel: FunctionComponent<Props> = (props: Props) => {
    const {tierId} = props;

    const [tierLabel, setTierLabel] = useState<string>('');
    const priceTiers = useSelector<GlobalApplicationState, PriceTier[] | undefined>(
        selectPriceTiersForOrganization
    );

    useEffect(() => {
        if (priceTiers) {
            const priceTier = _.find(priceTiers, {id: tierId});
            if (priceTier) {
                setTierLabel(priceTier.label);
            }
        }
    }, [priceTiers, tierId]);

    return (
        <Tooltip arrow title={tierLabel} placement="top">
            <div className="price-tier-label">
                <MonetizationOnIcon />
                Tier
            </div>
        </Tooltip>
    );
};

export default PriceTierLabel;
